import React from 'react';
import { Layout, Menu, Button, Space, Typography } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { 
  UserOutlined, 
  FileAddOutlined, 
  SearchOutlined, 
  TeamOutlined, 
  FileTextOutlined,
  LogoutOutlined,
  WechatOutlined,
  HomeOutlined,
  AppstoreOutlined,
  TagsOutlined,
  ScanOutlined,
  PictureOutlined
} from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

const { Header } = Layout;
const { Text } = Typography;

const AppHeader = () => {
  const { currentUser, logout, isAdmin } = useAuth();
  const location = useLocation();
  
  // 根据当前路径确定选中的菜单项
  const getSelectedKey = () => {
    const path = location.pathname;
    if (path === '/' || path === '') return 'home';
    
    // 系统管理相关路径
    if (path.startsWith('/admin')) return ['system-management', 'admin'];
    if (path.startsWith('/logs')) return ['system-management', 'logs'];
    if (path.startsWith('/wx-pusher')) return ['system-management', 'wx-pusher'];
    if (path.startsWith('/wx-templates')) return ['system-management', 'wx-templates'];
    if (path.startsWith('/system-config')) return ['system-management', 'system-config'];
    
    // 运单管理相关路径
    if (path.startsWith('/submit')) return ['shipment-management', 'submit'];
    if (path.startsWith('/query')) return ['shipment-management', 'query'];
    if (path.startsWith('/edit')) return ['shipment-management', 'query'];
    
    // 客户管理
    if (path.startsWith('/customers')) return 'customers';
    
    // 样品管理相关路径
    if (path.startsWith('/pattern-management')) return ['pattern-management', 'pattern-management-sub'];
    if (path.startsWith('/pattern-categories')) return ['pattern-management', 'pattern-categories'];
    if (path.startsWith('/pattern-search')) return ['pattern-management', 'pattern-search'];
    if (path.startsWith('/sample-processor')) return ['pattern-management', 'sample-processor'];
    
    return '';
  };

  // 菜单项配置
  const allMenuItems = [
    {
      key: 'home',
      icon: <HomeOutlined />,
      label: <Link to="/">主页</Link>,
      visible: true
    },
    {
      key: 'system-management',
      icon: <UserOutlined />,
      label: '系统管理',
      visible: isAdmin(),
      children: [
        {
          key: 'admin',
          label: <Link to="/admin">用户管理</Link>,
        },
        {
          key: 'logs',
          label: <Link to="/logs">系统日志</Link>,
        },
        {
          key: 'wx-pusher',
          label: <Link to="/wx-pusher">微信推送</Link>,
        },
        {
          key: 'wx-templates',
          label: <Link to="/wx-templates">推送模板</Link>,
        },
        {
          key: 'system-config',
          label: <Link to="/system-config">系统配置</Link>,
        }
      ]
    },
    {
      key: 'shipment-management',
      icon: <FileAddOutlined />,
      label: '运单管理',
      visible: true,
      children: [
        {
          key: 'submit',
          label: <Link to="/submit">提交运单</Link>,
        },
        {
          key: 'query',
          label: <Link to="/query">查询记录</Link>,
        }
      ]
    },
    {
      key: 'customers',
      icon: <TeamOutlined />,
      label: <Link to="/customers">客户管理</Link>,
      visible: true
    },
    {
      key: 'pattern-management',
      icon: <AppstoreOutlined />,
      label: '样品管理',
      visible: true,
      children: [
        {
          key: 'pattern-management-sub',
          label: <Link to="/pattern-management">样品管理</Link>,
        },
        {
          key: 'pattern-categories',
          label: <Link to="/pattern-categories">样品分类</Link>,
        },
        {
          key: 'pattern-search',
          label: <Link to="/pattern-search">样品搜索</Link>,
        },
        {
          key: 'sample-processor',
          label: <Link to="/sample-processor">样品处理</Link>,
        }
      ]
    }
  ];
  
  // 过滤可见菜单项，并移除visible属性
  const menuItems = allMenuItems
    .filter(item => item.visible)
    .map(({ visible, ...item }) => item);

  return (
    <Header style={{ position: 'sticky', top: 0, zIndex: 1, width: '100%', display: 'flex', alignItems: 'center' }}>
      <div className="logo">📦 仓库管理系统</div>
      <Menu
        theme="dark"
        mode="horizontal"
        selectedKeys={[getSelectedKey()]}
        items={menuItems}
        style={{ flex: 1, minWidth: 0 }}
      />
      <Space style={{ marginLeft: 'auto' }}>
        <Text style={{ color: 'white' }}>
          {currentUser ? `${currentUser.username} (${currentUser.role === 'admin' ? '管理员' : '用户'})` : ''}
        </Text>
        <Button 
          type="text" 
          icon={<LogoutOutlined />} 
          onClick={logout}
          style={{ color: 'white' }}
        >
          退出登录
        </Button>
      </Space>
    </Header>
  );
};

export default AppHeader;
